import type { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Image } from '$components/basic/Image';
import { Link } from '../Link';
import DivStyled from './styled';

export interface CallUsProps extends HTMLAttributes<HTMLDivElement> {
  readonly phoneNumber: string;
}

export function CallUs({ phoneNumber, className }: CallUsProps): JSX.Element {
  const phoneTrimmed = phoneNumber.replace(/\s/g, '');
  return (
    <DivStyled className={classNames('call-us', className)}>
      <Image
        className="call-us-icon"
        provider="cloudinary"
        src="/icons/icon_phone_black_hrde7r.svg"
        alt="Call us"
        layout="fixed"
        width="14"
        height="18"
      />
      <span>
        or call us on <Link href={`tel:+44${phoneTrimmed}`}>{phoneNumber}</Link>
      </span>
    </DivStyled>
  );
}

CallUs.displayName = 'CallUs';
